import { render, staticRenderFns } from "./aboutBanner.vue?vue&type=template&id=43bfb838&scoped=true&"
import script from "./aboutBanner.vue?vue&type=script&lang=js&"
export * from "./aboutBanner.vue?vue&type=script&lang=js&"
import style0 from "./aboutBanner.vue?vue&type=style&index=0&id=43bfb838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bfb838",
  null
  
)

export default component.exports